module.exports = __webpack_public_path__ + "img/weddings_04_V.c5817a67.webp";